export const en = {
  "header": {
    "brand": "CikaStudio",
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "nav": {
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "actions": {
    "copy": "Copy",
    "download": "Download",
    "clear": "Clear",
    "copied": "Copied!",
    "copyAll": "Copy All",
    "downloadTxt": "Download TXT",
    "generate": "Generate",
    "regenerate": "Regenerate",
    "format": "Format",
    "minify": "Minify",
    "validate": "Validate",
    "convert": "Convert"
  },
  "footer": {
    "privacy": "Privacy",
    "terms": "Terms",
    "email": "Contact",
    "moreTools": "More Tools",
    "copyright": "© {year} CikaStudio. All rights reserved."
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "Light",
    "dark": "Dark"
  },
  "common": {
    "clientSide": "100% client-side",
    "noUpload": "No data upload",
    "noAccount": "No account required",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success"
  },
  "caseConverter": {
    "title": "Case Converter",
    "subtitle": "Convert text between UPPER, lower, Title, camelCase, snake_case, and more. ",
    "privacy": "100% client-side",
    "inputLabel": "Input Text",
    "placeholder": "Type or paste text here...",
    "words": "Words",
    "chars": "Chars",
    "charsNoSpace": "No Spaces",
    "lines": "Lines",
    "emptyHint": "Type or paste text above to see all case conversions",
    "caseUpper": "UPPER CASE",
    "caseLower": "lower case",
    "caseTitle": "Title Case",
    "caseSentence": "Sentence case",
    "caseCamel": "camelCase",
    "casePascal": "PascalCase",
    "caseSnake": "snake_case",
    "caseKebab": "kebab-case",
    "caseConstant": "CONSTANT_CASE",
    "caseAlternating": "aLtErNaTiNg",
    "caseReverse": "esreveR"
  },
  "content": {
    "privacy": {
      "title": "Privacy & Security",
      "description": "🔒 All text processing happens locally in your browser. Your text is never uploaded to any server."
    },
    "guide": {
      "title": "How to Use Case Converter",
      "description": "Convert text between uppercase, lowercase, Title Case, camelCase, snake_case, and more instantly.",
      "steps": [
        {
          "title": "Paste your text",
          "description": "Copy and paste any text into the input field. The tool handles paragraphs, code snippets, variable names, and entire documents."
        },
        {
          "title": "Select conversion mode",
          "description": "Choose from UPPER CASE, lower case, Title Case, camelCase, PascalCase, snake_case, kebab-case, and more."
        },
        {
          "title": "Copy converted text",
          "description": "The output updates in real-time as you type. Click copy to save the converted text to your clipboard for immediate use."
        }
      ]
    },
    "features": {
      "title": "Key Features",
      "items": [
        "10+ case conversion modes including programming cases",
        "Real-time output as you type",
        "Handles special characters and Unicode text",
        "One-click copy to clipboard",
        "Character and word count display",
        "100% client-side processing — zero data upload"
      ]
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "items": [
        {
          "question": "Is my text sent to a server?",
          "answer": "No. All conversion happens entirely within your browser. Your text never leaves your device, making it safe for sensitive code, names, and documents."
        },
        {
          "question": "What is camelCase vs PascalCase?",
          "answer": "camelCase starts with a lowercase letter (e.g., myVariableName), while PascalCase starts with uppercase (e.g., MyClassName). Both remove spaces and capitalize each subsequent word."
        },
        {
          "question": "Does it handle non-English text?",
          "answer": "Yes. The converter properly handles Unicode characters including accented letters, Cyrillic, Chinese, Japanese, and Arabic text for case transformations where applicable."
        }
      ]
    },
    "related": {
      "title": "Related Tools",
      "tools": [
        {
          "name": "Lorem Ipsum Generator",
          "url": "/text/lorem-ipsum-generator",
          "description": "Generate placeholder text for design, development, and content mockups."
        },
        {
          "name": "Markdown Editor",
          "url": "/text/markdown-editor",
          "description": "Write and preview Markdown in real-time with syntax highlighting."
        },
        {
          "name": "Regex Tester",
          "url": "/developer/regex-tester",
          "description": "Test regular expressions in real-time with match highlighting."
        }
      ]
    }
  }
};
